document.addEventListener('DOMContentLoaded', function () {
  var pages = document.querySelectorAll('.gallery-grid-page');
  if (!pages.length) return;

  if (pages.length > 1) {
    var nav = document.createElement('div');
    nav.className = 'gallery-grid-nav';

    pages.forEach(function (page, index) {
      var label = page.getAttribute('data-gallery-label') || ('Pagina ' + (index + 1));
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gallery-grid-nav__btn';
      btn.textContent = label;
      if (index === 0) {
        btn.classList.add('is-active');
      }
      btn.addEventListener('click', function () {
        pages.forEach(function (p) {
          p.classList.remove('is-active');
        });
        nav.querySelectorAll('.gallery-grid-nav__btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        page.classList.add('is-active');
        btn.classList.add('is-active');
      });
      nav.appendChild(btn);
    });

    pages[0].parentNode.insertBefore(nav, pages[0]);
  }

  pages[0].classList.add('is-active');
});
